import { render, staticRenderFns } from "./VirtualEstimates.vue?vue&type=template&id=403dec5d"
import script from "./VirtualEstimates.vue?vue&type=script&lang=js"
export * from "./VirtualEstimates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports